export const AUDIO_PHASE1_ALLOWED_ROUTE_NAMES = [
  'Audio',
  'AudioFavorite',
  'AudioLog'
]

export const AUDIO_PHASE1_DEPRECATED_ROUTES = [
  {
    path: 'audio-category',
    name: 'AudioCategory',
    title: '音频分类'
  },
  {
    path: 'audio-element',
    name: 'AudioElement',
    title: '音频元素'
  },
  {
    path: 'ai-generated-audio',
    name: 'AIGeneratedAudio',
    title: 'AI生成的音频'
  },
  {
    path: 'ai-audio-generation',
    name: 'AIAudioGeneration',
    title: 'AI定时生成元素音频'
  }
]

export const AUDIO_PHASE1_DEPRECATED_ROUTE_NAMES = AUDIO_PHASE1_DEPRECATED_ROUTES.map(
  route => route.name
)

export function isAudioPhase1DeprecatedRoute(routeName) {
  return AUDIO_PHASE1_DEPRECATED_ROUTE_NAMES.includes(routeName)
}

export function getAudioPhase1FallbackRoute(permissions = []) {
  const routeName = AUDIO_PHASE1_ALLOWED_ROUTE_NAMES.find(name => permissions.includes(name))
  return routeName ? { name: routeName } : '/'
}
